import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"
import { PeriodData } from "./PeriodData";
import { MoodData } from "./MoodData";
import { SymptomData } from "./SymptomData";
import { PeriodDay } from "./PeriodDay";
import { Activity } from "./Activity";
import { Miscellaneous } from "./Miscellaneous";
import { SexAndLibido } from "./SexAndLibido";


interface StringKeyArray {
    [index: string]: number;
}

export class MultipleDayBooleanInputs{
     attributePrefix = "";
     attributePrefixDe = "";

     constructor(concrete: String){
        switch(concrete){
            case 'PeriodData':
                this.attributePrefix = PeriodData.attributePrefix;
                this.attributePrefixDe = PeriodData.attributePrefixDe;
                break;
            case 'MoodData':
                this.attributePrefix = MoodData.attributePrefix;
                this.attributePrefixDe = MoodData.attributePrefixDe;
                break;
            case 'SymptomData':
                this.attributePrefix = SymptomData.attributePrefix;
                this.attributePrefixDe = SymptomData.attributePrefixDe;
                break;
            case 'PeriodDay':
                this.attributePrefix = PeriodDay.attributePrefix;
                this.attributePrefixDe = PeriodDay.attributePrefixDe;
                break;
            case 'Activity':
                this.attributePrefix = Activity.attributePrefix;
                this.attributePrefixDe = Activity.attributePrefixDe;
                break;
            case 'Miscellaneous':
                this.attributePrefix = Miscellaneous.attributePrefix;
                this.attributePrefixDe = Miscellaneous.attributePrefixDe;
                break;
            case 'SexAndLibido':
                this.attributePrefix = SexAndLibido.attributePrefix;
                this.attributePrefixDe = SexAndLibido.attributePrefixDe;
                break;
            default:
                console.log("error: the called: "+concrete+" isn't implemented");
                break;
        }
     }

     public getDeName(engname: String){
        //console.log(this)
        //console.log(engname)
        let myAttributeNames = DataSafe.myAttributes();
        let myAttributeNamesDe = DataSafe.myAttributesDe();
        /* @ts-ignore */
        //console.log(myAttributeNames.indexOf(this.attributePrefix+'_'+engname))
        if(myAttributeNames.indexOf(this.attributePrefix+'_'+engname) > 0){
            /* @ts-ignore */
            return myAttributeNamesDe[myAttributeNames.indexOf(this.attributePrefix+'_'+engname)].replace(this.attributePrefixDe+"_","");
        }
    }

    public getMyAttributeNumbers(){
        //let myClassName = this.name;
        let myAttributeNames = DataSafe.myAttributes();
        let thisattributePrefix = this.attributePrefix;
        let attributes = {};
        myAttributeNames.forEach(function(value,index){
            let prefixPart = value.split("_")
            if(prefixPart.length > 1){
                /* @ts-ignore */
                if(prefixPart[0].includes(thisattributePrefix)){
                    /* @ts-ignore */
                    let key = value.replace(thisattributePrefix+"_","");
                
                    /* @ts-ignore */
                    attributes[key.toString()]=index;
                }
            }
        });

        // see DataSafe !!!
        return attributes;
    }

    public getSetUpArray(){
        //let myClassName = this.name;
        let myAttributeNames = DataSafe.myAttributes();
        let thisattributePrefix = this.attributePrefix;
        let attributes = {};
        myAttributeNames.forEach(function(value,index){
            let prefixPart = value.split("_")
            if(prefixPart.length > 1){
                /* @ts-ignore */
                if(prefixPart[0].includes(thisattributePrefix)){
                    /* @ts-ignore */
                    let key = value.replace(thisattributePrefix+"_","");
                    // console.log(index);
                    /* @ts-ignore */
                    attributes[key.toString()]=false;
                }
            }
        });

        // see DataSafe !!!
        return attributes;
    }


        /* @ts-ignore */
        public async insertOrUpdateToDate(vals,ValueDate){
            await AppUsers.getMyUser().then((user) => {
                let vars = {};
                let myAttributes = this.getMyAttributeNumbers();
                let defaultKeys = Object.keys(myAttributes);
                for(var i = 0; i < defaultKeys.length; i++){
                    let helpkey = defaultKeys[i];
    
                    if(typeof vals[helpkey] != 'undefined'){
                        /* @ts-ignore */
                        vars[myAttributes[helpkey]] = vals[helpkey];
                    }
                }
    
                DataSafe.insertOrUpdateToDate(user.sysId, vars, ValueDate );
            });
        }


    public async getMyDayValues(ShowDate: Date){
        //console.log('getData')
        return await AppUsers.getMyUser().then((user) => {
            //console.log(Object.values(ProfileData.getMyAttributeNumbers()));
            /* @ts-ignore */
            let myAttributes = this.getMyAttributeNumbers();
            let setUpArray = this.getSetUpArray();
            //console.log(myAttributes)
            return DataSafe.getDayValuesToAttributes(user.sysId, Object.values(myAttributes), ShowDate ).then((res) => {
                /* @ts-ignore */
                let defaultRet = setUpArray;
                let defaultKeys = Object.keys(defaultRet);
                for(var i = 0; i < defaultKeys.length; i++){
                    let helpkey = defaultKeys[i];
                    //console.log(myAttributes)
                    /* @ts-ignore */
                    if(typeof res.get(myAttributes[helpkey]) != 'undefined'){
                        //console.log(res.get(myAttributes[helpkey]).value)
                        /* @ts-ignore */
                        defaultRet[helpkey] = res.get(myAttributes[helpkey]).value;
                    }
                }
                //console.log(defaultRet)
                return defaultRet;
            });
        });
    }

    public async getAllMyValues(){
        //console.log('getData')
        return await AppUsers.getMyUser().then((user) => {
            //console.log(Object.values(ProfileData.getMyAttributeNumbers()));
            /* @ts-ignore */
            let myAttributes = this.getMyAttributeNumbers();
            let setUpArray = this.getSetUpArray();
            //console.log(myAttributes) getAllValuesToAttributeNbs(user: string, attributeNumbers: Array<number>, JSONparse: boolean)
            return DataSafe.getAllValuesToAttributeNbs(user.sysId, Object.values(myAttributes),false );
        });
    }
}